module.exports = __webpack_public_path__ + "static/media/newsletter-december-2022-7.966728e3.jpg";